import { Link } from "react-router-dom";
import { getHotArticles, formatDate } from "@/lib/news";

export default function HotSection() {
  const hot = getHotArticles(6);

  return (
    <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-fire-line text-lg" />
        </span>
        <div>
          <h2 className="font-heading text-base font-bold text-foreground-950">
            热门黑料推荐
          </h2>
          <p className="text-xs text-foreground-500">依据关注度虚拟排序</p>
        </div>
      </div>

      <ol className="space-y-1">
        {hot.map((article, index) => (
          <li key={article.id}>
            <Link
              to={`/detail/${article.id}`}
              className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100 cursor-pointer"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-label font-bold ${
                  index < 3
                    ? "bg-accent-500 text-accent-950"
                    : "bg-secondary-100 text-secondary-700"
                }`}
              >
                {index + 1}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-2 text-sm font-medium leading-6 text-foreground-900 transition-colors group-hover:text-primary-600">
                  {article.title}
                </h3>
                <div className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                  <span>{article.categoryName}</span>
                  <span>·</span>
                  <span>{formatDate(article.publishedAt)}</span>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}